import Vue from 'vue'
import axios from 'axios'
import config from '../config'

// Haversine formula to calculate straight-line distance between two points
function calculateDistance(lat1, lng1, lat2, lng2) {
  const R = 6371e3 // Earth's radius in meters
  const φ1 = (lat1 * Math.PI) / 180
  const φ2 = (lat2 * Math.PI) / 180
  const Δφ = ((lat2 - lat1) * Math.PI) / 180
  const Δλ = ((lng2 - lng1) * Math.PI) / 180

  const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return R * c // Distance in meters
}

const defaultStore = {
  state: {
    search: {
      tab: 'times',
      phrase: '',
      location: '',
      loading: false
    },
    map: {
      center: { lat: 47.130307, lng: 19.203601 },
      origin: { lat: 47.130307, lng: 19.203601 },
      zoom: 8
    },
    garages: []
  },

  actions: {
    FETCH_GARAGES(store) {
      return axios
        .get('/garages/ordered', config.AXIOS_DEFAULTS)
        .then((response) => {
          store.commit('setGarages', response.data)
          store.commit('sortGarages')
        })
        .catch((error) => {
          console.error(error)
        })
    },

    SWITCH_TAB(store, payload) {
      store.commit('setTab', payload)
      store.commit('sortGarages')
    },

    async START_SEARCH(store, payload) {
      store.commit('setPhrase', payload)

      if (payload === '') {
        store.commit('setOrigin', config.MAP_DEFAULT_CENTER)
        store.commit('setCenter', config.MAP_DEFAULT_CENTER)
        store.commit('setZoom', config.MAP_DEFAULT_ZOOM)
      } else {
        let searchQuery = payload
        const zip = parseInt(payload)

        if (payload.length === 4 && zip === payload) {
          searchQuery = `${payload} Magyarország`
        }

        try {
          // Use Nominatim for geocoding (OpenStreetMap)
          const baseUrl = 'https://nominatim.openstreetmap.org/search'
          const params = `format=json&q=${encodeURIComponent(searchQuery)}&countrycodes=hu&limit=1`
          const response = await fetch(`${baseUrl}?${params}`, {
            headers: { 'Accept-Language': 'hu' }
          })
          const results = await response.json()

          if (results && results.length > 0) {
            const location = {
              lat: parseFloat(results[0].lat),
              lng: parseFloat(results[0].lon)
            }
            store.commit('setOrigin', location)
            store.commit('setCenter', location)
            store.commit('setZoom', 13)
            store.commit('setLocation', results[0].display_name)
            store.dispatch('SWITCH_TAB', 'distance')
          }
        } catch (error) {
          console.error('Geocoding error:', error)
        }
      }
    }
  },

  mutations: {
    setPhrase(state, payload) {
      Vue.set(state.search, 'phrase', payload)
    },

    setTab(state, payload) {
      Vue.set(state.search, 'tab', payload)
    },

    setGarages(state, payload) {
      payload.map((row) => {
        const latlng = row.google_latlong.split(',')
        row.latLng = {
          lat: parseFloat(latlng[0]),
          lng: parseFloat(latlng[1])
        }
      })

      Vue.set(state, 'garages', payload)
    },

    sortGarages(state) {
      const garagesData = state.garages

      if (state.search.tab === 'times') {
        Vue.set(state, 'garages', garagesData)
      }

      if (state.search.tab === 'distance' && state.search.location) {
        Vue.set(state.search, 'loading', true)

        // Calculate straight-line distance using Haversine formula
        garagesData.forEach((row) => {
          const { lat: oLat, lng: oLng } = state.map.origin
          const { lat: gLat, lng: gLng } = row.latLng
          row.distance = calculateDistance(oLat, oLng, gLat, gLng)
        })

        garagesData.sort((a, b) => (a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0))
        Vue.set(state, 'garages', garagesData)
        Vue.set(state.search, 'loading', false)
      }
    },

    setLocation(state, payload) {
      Vue.set(state.search, 'location', payload)
    },

    setOrigin(state, payload) {
      Vue.set(state.map, 'origin', payload)
    },

    setCenter(state, payload) {
      Vue.set(state.map, 'center', payload)
    },

    setZoom(state, payload) {
      Vue.set(state.map, 'zoom', payload)
    }
  },

  getters: {
    phrase(state) {
      return state.search.phrase
    },

    location(state) {
      return state.search.location
    },

    garages(state) {
      return state.garages
    },

    map(state) {
      return state.map
    }
  }
}

export default defaultStore
